"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _AbstractClassException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractClassException"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

var _PriceFormatter = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/PriceFormatter"));

var _StringUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/StringUtility"));

var _ikeaSharedServices = require("@ikea-aoa/ikea-shared-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Components that needs localized content like translations and prices should extend this class.
 */
var AbstractLocalizedComponent = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(AbstractLocalizedComponent, _AbstractComponent);

  var _super = _createSuper(AbstractLocalizedComponent);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function AbstractLocalizedComponent(element) {
    var _this;

    _classCallCheck(this, AbstractLocalizedComponent);

    _this = _super.call(this, element);

    if (_this.constructor === AbstractLocalizedComponent) {
      throw new _AbstractClassException.default();
    }

    _this.isLocalizationLoaded = false;
    _this.localized = {
      localization: {},
      translations: {},
      prices: {},
      iconImages: {},
      urls: {},
      uiPlatform: _ikeaSharedServices.ServiceSettings.uiPlatform
    };
    _this._localizationTimeout = null;
    return _this;
  }
  /**
   * Renders the component.
   *
   * @override
   * @param {boolean} [forced=false] Will force render of child components.
   */


  _createClass(AbstractLocalizedComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isLocalizationLoaded) {
        _get(_getPrototypeOf(AbstractLocalizedComponent.prototype), "render", this).call(this, forced);
      } else {
        var localized = _ikeaSharedServices.LocalizationServiceFacade.getCacheItem('localization');

        var urls = _ikeaSharedServices.ApplicationUrlServiceFacade.getCacheItem('urls');

        if (localized && localized.translations && urls && typeof urls.PIP === 'string') {
          this._parseLocalization(localized, urls);

          this._localizationTimeout = setTimeout(function () {
            _this2.trigger('localization', _this2.localized);
          });

          _get(_getPrototypeOf(AbstractLocalizedComponent.prototype), "render", this).call(this, forced);
        } else {
          Promise.all([_ikeaSharedServices.LocalizationServiceFacade.getData(), _ikeaSharedServices.ApplicationUrlServiceFacade.getUrls()]).then(function (responses) {
            if (!_this2.isDestroyed) {
              _this2._parseLocalization(responses[0], responses[1]);

              _this2.debounceRender(forced);

              _this2.trigger('localization', _this2.localized);
            }
          }).catch(function (error) {
            if (error.message.includes('404')) {
              throw new _ServiceException.default('This locale has not been configured in Translation Tool.');
            }

            throw error;
          });
        }
      }
    }
    /**
     * Parse localization.
     *
     * @param {object} localized Localization object.
     * @param {object} urls Urls.
     */

  }, {
    key: "_parseLocalization",
    value: function _parseLocalization(localized, urls) {
      Object.assign(this.localized, localized);
      this.isLocalizationLoaded = true;

      if (this.localized.URLs) {
        this.localized.urls = Object.assign({}, this.localized.URLs);
        delete this.localized.URLs;
      }

      Object.assign(this.localized.urls, urls);
    }
    /**
     * Returns a translation for a key.
     *
     * @param {string} key Translation key.
     * @param {object} replace Object with key/value pairs of translation keys to replace. "[[" will be prepended and "]]" will be appended to the key before replaced.
     * @returns {string} Translated label.
     */

  }, {
    key: "translate",
    value: function translate(key, replace) {
      var value = this.localized.translations[key] !== undefined ? this.localized.translations[key] : key;

      if (replace) {
        for (var _key in replace) {
          if (replace.hasOwnProperty(_key)) {
            value = value.replace('[[' + _key + ']]', replace[_key]);
          }
        }
      }

      switch (key) {
        case 'ADD_TO_SHOPPING_CART_SUCCESS_PARAGRAPH':
          value = value.replace('[[shopping_cart]]', this._getTranslateLink('ADD_TO_SHOPPING_CART_NAME', this.localized.urls.SHOPPINGCART));
          break;

        case 'ADD_TO_SHOPPING_LIST_SUCCESS_PARAGRAPH':
          value = value.replace('[[shopping_list]]', this._getTranslateLink('ADD_TO_SHOPPING_LIST_NAME', this.localized.urls.SHOPPINGLIST));
          break;

        case 'ADD_TO_SHOPPING_CART_FAILURE_PARAGRAPH':
          value = value.replace('[[shopping_cart]]', this._getTranslateLink('ADD_TO_SHOPPING_CART_FAILURE_LINK', this.localized.urls.SHOPPINGCART));
          break;

        case 'ADD_TO_SHOPPING_LIST_FAILURE_PARAGRAPH':
          value = value.replace('[[shopping_list]]', this._getTranslateLink('ADD_TO_SHOPPING_LIST_FAILURE_LINK', this.localized.urls.SHOPPINGLIST));
          break;
      }

      if (value.indexOf('[[applicationname]]') !== -1 && (_ikeaSharedServices.ServiceSettings.applicationName || _ikeaSharedServices.ServiceSettings.applicationTranslationName)) {
        return value.replace('[[applicationname]]', (_ikeaSharedServices.ServiceSettings.applicationTranslationName || _ikeaSharedServices.ServiceSettings.applicationName).toUpperCase());
      }

      return value;
    }
    /**
     * Returns TRUE if kiosk.
     *
     * @returns {boolean} TRUE if kiosk.
     */

  }, {
    key: "isKiosk",
    value: function isKiosk() {
      return this.settings.uiPlatform.includes('kiosk');
    }
    /**
     * Generates a price localized.
     *
     * @param {number} amount The price amount.
     * @param {object} [article] An article object returned from ArticleServiceFacade when price should be displayed for a single item. Additional information like package information will be added.
     * @returns {string} Price rendered localized.
     */

  }, {
    key: "price",
    value: function price(amount) {
      var article = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (article !== null) {
        return _PriceFormatter.default.formatForArticle(amount, this.localized.prices, article);
      }

      return _PriceFormatter.default.format(amount, this.localized.prices);
    }
    /**
     * Returns an article image path.
     *
     * @param {object} article Article object.
     * @param {string} [imageSize] Image size. Default is S5.
     * @returns {string|null} Image path.
     */

  }, {
    key: "getArticleImage",
    value: function getArticleImage(article) {
      var imageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'S5';

      if (article.Images && Array.isArray(article.Images[imageSize]) && article.Images[imageSize].length > 0 && article.Images[imageSize][0].Url && !article.Images[imageSize][0].Url.endsWith('missingImage.jpg')) {
        return article.Images[imageSize][0].Url;
      }

      return null;
    }
    /**
     * Parses an item string.
     *
     * @param {string|null} itemString Item string in the following format: "{type},{itemNo};{type},{itemNo}".
     * @returns {object[]} Items.
     */

  }, {
    key: "_parseItemString",
    value: function _parseItemString(itemString) {
      var items = [];

      if (itemString) {
        var propItems = itemString.split(';');

        var _iterator = _createForOfIteratorHelper(propItems),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var propItem = _step.value;
            var filterSplit = propItem.split(':');
            var itemData = filterSplit[0].split(',');

            if (itemData.length >= 2) {
              var item = {
                type: itemData[0],
                id: itemData[1]
              };

              if (filterSplit.length > 1) {
                item.filters = filterSplit[1].split(',');
              }

              items.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return items;
    }
    /**
     * Parses an item string with qty.
     *
     * @param {string|null} itemString Item string in the following format: "{type},{itemNo},{qty};{type},{itemNo},{qty}".
     * @returns {object[]} Items.
     */

  }, {
    key: "_parseItemQtyString",
    value: function _parseItemQtyString(itemString) {
      var items = [];

      if (itemString) {
        var propItems = itemString.split(';');

        var _iterator2 = _createForOfIteratorHelper(propItems),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var propItem = _step2.value;
            var filterSplit = propItem.split(':');
            var itemData = filterSplit[0].split(',');

            if (itemData.length >= 3) {
              var qty = parseInt(itemData[2]);
              var item = {
                type: itemData[0],
                id: itemData[1],
                qty: !isNaN(qty) ? qty : 0
              };

              if (filterSplit.length > 1) {
                item.filters = filterSplit[1].split(',');
              }

              if (itemData.length >= 4) {
                item.category = itemData[3];
              }

              items.push(item);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return items;
    }
    /**
     * Formats article measurements.
     *
     * @param {object} article Article containing meassurements.
     * @param {boolean} [useValidDesignText] If validDesignText should be appended..
     * @returns {string} Formatted measurements.
     */

  }, {
    key: "_formatArticleMeasurements",
    value: function _formatArticleMeasurements(article) {
      var useValidDesignText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var useMetricMeasures = this.localized.localization.useMetricMeasures !== false;
      var measurements = article.Measurements.map(function (measure) {
        return measure.Type + ': ' + (useMetricMeasures ? measure.MetricValue : measure.ImperialValue);
      }).join(', ');

      if (useValidDesignText && article.ValidDesignText) {
        measurements = _StringUtility.default.capitalizeFirstLetter(article.ValidDesignText) + (measurements ? ', ' + measurements : '');
      }

      return measurements;
    }
    /**
     * Returns translation link.
     *
     * @param {string} key Translation key.
     * @param {string} url URL to use.
     * @param {boolean} openInWindow TRUE to open in new window. Default is TRUE.
     * @returns {string} Translated link as HTML.
     */

  }, {
    key: "_getTranslateLink",
    value: function _getTranslateLink(key, url) {
      var openInWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var target = openInWindow ? ' target="_blank"' : '';
      return "<a data-translation-key=\"".concat(key, "\" href=\"").concat(url, "\"").concat(target, ">").concat(this.translate(key), "</a>");
    }
    /**
     * Destroys all references to the component and calls destroy().
     *
     * @override
     */

  }, {
    key: "destroyAll",
    value: function destroyAll() {
      clearTimeout(this._localizationTimeout);

      _get(_getPrototypeOf(AbstractLocalizedComponent.prototype), "destroyAll", this).call(this);
    }
    /**
     * Gets the default events.
     * Adds "localization" to default events.
     *
     * @override
     * @returns {string[]} Array of supported default event names. Default: ['load', 'render'].
     */

  }], [{
    key: "_defaultEvents",
    get: function get() {
      return _get(_getPrototypeOf(AbstractLocalizedComponent), "_defaultEvents", this).concat(['localization']);
    }
  }]);

  return AbstractLocalizedComponent;
}(_ikeaSharedComponent.AbstractComponent);

exports.default = AbstractLocalizedComponent;